import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["lazyload", "fillFrame", "src", "alt", "colorBlock", "fallbackContent", "aspectRatio", "width", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import styled, { css } from 'styled-components';
import { getLength, getSolidBackgroundShade } from 'utils/ui';
import { fillParent } from 'styles/mixins';
import { z } from 'styles/globals';
import ThemeSection from 'components/ThemeSection';
import LazyImage, { ImageWithLoader } from 'components/LazyImage';
import Box from 'components/Box';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function getRatioPercentage(ratio) {
  if (typeof ratio === 'string') {
    return ratio;
  }
  return "".concat(ratio * 100, "%");
}
function shouldForwardProp(prop) {
  return !['width', 'aspectRatio'].includes(prop);
}
var StyledBox = styled(Box).attrs({
  role: 'presentation'
}).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "CardImage__StyledBox",
  componentId: "sc-m2srgn-0"
})(["position:relative;display:block;width:", ";overflow:hidden;color:", ";", ""], function (p) {
  return p.width ? getLength(p.width) : '100%';
}, function (p) {
  return p.theme.text;
}, function (p) {
  return p.aspectRatio && css(["&::before{content:'';display:table;float:left;width:1px;margin-left:-1px;padding-bottom:", ";}"], getRatioPercentage(p.aspectRatio));
});
var Content = styled.div.withConfig({
  displayName: "CardImage__Content",
  componentId: "sc-m2srgn-1"
})(["", " z-index:", ";display:flex;align-items:center;justify-content:center;"], fillParent, z.flat);
function CardImage(_ref) {
  var _ref$lazyload = _ref.lazyload,
    lazyload = _ref$lazyload === void 0 ? true : _ref$lazyload,
    _ref$fillFrame = _ref.fillFrame,
    fillFrame = _ref$fillFrame === void 0 ? true : _ref$fillFrame,
    src = _ref.src,
    alt = _ref.alt,
    colorBlock = _ref.colorBlock,
    fallbackContent = _ref.fallbackContent,
    aspectRatio = _ref.aspectRatio,
    width = _ref.width,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var hasImage = !!src;
  var ImageComponent = lazyload ? LazyImage : ImageWithLoader;
  return /*#__PURE__*/_jsx(ThemeSection, {
    name: fillFrame ? colorBlock : undefined,
    withBackgroundImage: hasImage,
    children: /*#__PURE__*/_jsxs(StyledBox, _objectSpread(_objectSpread({
      width: width,
      backgroundColor: function backgroundColor(theme) {
        return hasImage ? theme.background : getSolidBackgroundShade(theme);
      },
      aspectRatio: aspectRatio
    }, otherProps), {}, {
      children: [hasImage && /*#__PURE__*/_jsx(ImageComponent
      // The key ensures that the component is
      // recreated when the `src` changes
      , {
        src: src,
        alt: alt,
        fillFrame: fillFrame
      }, src), (!hasImage || children) && /*#__PURE__*/_jsxs(Content, {
        children: [!hasImage && fallbackContent, children]
      })]
    }))
  });
}
export default CardImage;